module.exports = __webpack_public_path__ + "img/dots.f6ac23d1.svg";